export default __webpack_public_path__ + "static/media/bg2880.5048ba66.png";